import * as Yup from 'yup';
export const ConnectValidationSchema = Yup.object().shape({
    pixelId: Yup.string().required(),
    accessToken: Yup.string()
        .required('Access token is required')
        .test('is-meta-token', 'Please enter a valid Meta access token', (value) => {
        if (!value)
            return false;
        // Meta access tokens typically:
        // - Are long strings (usually 100+ characters)
        // - Contain alphanumeric characters and some special characters
        // - May start with specific prefixes like 'EAA' for app access tokens
        const isValidLength = value.length >= 100 && value.length <= 300;
        const containsValidChars = /^[A-Za-z0-9_|-]+$/.test(value);
        return isValidLength && containsValidChars;
    }),
});
